// extracted by mini-css-extract-plugin
export default {"back":"Landing_back__Ld2rO","image":"Landing_image__+iBJF","textBox":"Landing_textBox__3t9iE","text":"Landing_text__mXrOv","button":"Landing_button__8MXUf"};